export const getSortedHardwareScripts = ({
  inventoryHardwareScripts,
}: HardwareScriptsQueryResponse): HardwareScript[] =>
  inventoryHardwareScripts.sort((a, b) => a.name.localeCompare(b.name));
